<page-title
  i18n-text="@@cryptoPageDetail.title"
  text="{{ currency?.name }} Price Today to {{ baseCurrencyInfo?.name }} | {{
    currency?.name
  }} Real-Time Value & Charts | Bit Oasis
"
>
</page-title>

<ng-container [ngSwitch]="currency?.code">
  <page-meta
    i18n-description="@@cryptoPageDetail.metaDescription"
    description="Explore the price of {{ currency?.name }} against {{
      baseCurrencyInfo?.name
    }} with live data, market capitalization, and trading volume. Follow trends and trade {{
      currency?.name
    }} safely via BitOasis.
"
  >
  </page-meta>

  <site-layout *ngIf="fullLayout">
    <ng-container *ngTemplateOutlet="coinDetails"></ng-container>
  </site-layout>
  <ng-container *ngIf="!fullLayout">
    <div class="coin-details-wrapper px-2">
      <ng-container *ngTemplateOutlet="coinDetails"></ng-container>
    </div>
  </ng-container>
  <site-footer *ngIf="fullLayout"></site-footer>
  <ng-template #coinDetails>
    <loading *ngIf="loading" class="full">
      <ng-container i18n="@@pricePage.loading">Loading Data ...</ng-container>
    </loading>

    <error *ngIf="!loading && error" class="full">
      {{ error }}
    </error>

    <div *ngIf="!loading && !error" class="wrapper">
      <div class="row top mt-0" *ngIf="fullLayout">
        <div class="col-8 col-lg-10">
          <nav class="breadcrumb p-3" aria-label="breadcrumb">
            <a routerLink="/home" i18n="@@breadcrumb.front.home">Home</a>
            <div class="separator"></div>
            <a routerLink="/prices" i18n="@@breadcrumb.front.prices">Prices</a>
            <div class="separator"></div>
            <span>{{ currency?.name }}</span>
          </nav>
        </div>
        <div class="col-4 col-lg-2 py-3 text-end">
          <price-alert-button
            buttonStyle="button"
            location="Price Page"
            [pair]="pair"
            [useGlobalCurrency]="false"
          ></price-alert-button>
        </div>
      </div>
      <p *ngIf="fullLayout" class="page-subtitle" i18n="@@cryptoPageDetail.subtitle">Track the {{ currency?.name }} price in {{ baseCurrency }}, access <a routerLink="/prices">live crypto prices</a>, and stay updated with real-time trends using accurate data and live crypto charts.</p>

      <div class="top box mt-0" [class.glass-panel]="fullLayout">
        <div class="row header-breadcrumb mb-3" *ngIf="!fullLayout">
          <div class="col-8 col-lg-10">
            <nav class="breadcrumb pt-2 mb-0" aria-label="breadcrumb">
              <a routerLink="/dashboard" i18n="@@menu.overview">Overview</a>
              <div class="separator"></div>
              <span>{{ currency?.name }}</span>
            </nav>
          </div>
          <div class="col-4 col-lg-2 text-end">
            <price-alert-button
              buttonStyle="button"
              location="Price Page"
              [pair]="pair"
              [useGlobalCurrency]="false"
            ></price-alert-button>
          </div>
        </div>
        <header class="header row align-items-center">
          <div
            class="title col-lg col-12 d-flex flex-wrap align-items-center gap-2"
          >
            <currency
              [currency]="currency?.code"
              [useDefaultTheme]="false"
            ></currency>
            <h1 class="name">
              {{ currency?.name }}
              <span class="code text-lg text-gray">{{ pair }}</span>
            </h1>
            <!-- TODO: create a pipe for adding + -->
            <div class="d-flex gap-2">
              <span
                class="text-bold ltr"
                [ngClass]="
                  data?.isPositvitePriceChange
                    ? 'change-badge-primary'
                    : 'change-badge-danger'
                "
                >{{ data?.isPositvitePriceChange ? "+" : ""
                }}{{
                  data?.priceChangePercentage || 0 | number : "0.2-2"
                }}%</span
              >
              <span class="change-badge-warning"
                ><i class="icon-union"></i>#{{
                  coinInfo?.metadata?.rank || "--"
                }}
              </span>
            </div>
          </div>
          <ng-container [ngSwitch]="mainCurrency">
            <div class="col-lg-1 col-4 pt-3 pt-lg-0">
              <a
                routerLink="/lite/exchange/buy"
                [queryParams]="{ to: mainCurrency, from: baseCurrency }"
                class="btn d-flex gap-1 justify-content-center btn-primary"
              >
                <i class="icon icon-plus-1"></i>
                <span i18n="@@broker.priceChart.action.buy">Buy</span>
              </a>
            </div>
            <div class="col-lg-1 col-4 pt-3 pt-lg-0">
              <a
                routerLink="/lite/exchange/sell"
                [queryParams]="{ from: mainCurrency, to: baseCurrency }"
                class="btn d-flex gap-1 justify-content-center btn-block btn-danger"
              >
                <span class="icon-subtraction">-</span>
                <span i18n="@@broker.priceChart.action.sell">Sell</span>
              </a>
            </div>
            <div class="col-lg-1 col-4 pt-3 pt-lg-0">
              <a
                routerLink="/lite/exchange/swap"
                [queryParams]="{ from: mainCurrency }"
                class="btn d-flex gap-1 justify-content-center btn-block btn-swap"
              >
                <span class="icon-swap"></span>
                <span i18n="@@core2.exchange.mode.swap">Swap</span>
              </a>
            </div>
          </ng-container>
        </header>
        <!-- .header -->

        <div class="chart-info row align-items-center">
          <div class="col-lg">
            <div class="price">
              <div class="item-price">
                <span class="text-bold"
                  >{{ data?.baseCurrency?.currency }}
                  {{
                    data?.baseCurrency?.lastPrice || 0 | roundNumberPrice
                  }}</span
                >
                <span
                  *ngIf="data?.baseCurrency?.priceChange"
                  class="text-primary text-sm ms-1"
                  [class.text-danger]="!data?.isPositvitePriceChange"
                >
                  ({{ data?.isPositvitePriceChange ? "+" : ""
                  }}{{ data?.baseCurrency?.priceChange | roundNumberPrice }})
                </span>
              </div>
              <div
                class="item-price text-sm text-gray"
                *ngIf="
                  useGlobalCurrency &&
                  data?.baseCurrency?.currency !==
                    data?.defaultCurrency?.currency
                "
              >
                <span class="text-md"
                  >{{ data?.defaultCurrency?.currency }}
                  {{
                    data?.defaultCurrency?.lastPrice || 0 | roundNumberPrice
                  }}</span
                >
                <span
                  *ngIf="data?.defaultCurrency?.priceChange"
                  class="text-primary text-sm ltr ms-1"
                  [class.text-danger]="!data?.isPositvitePriceChange"
                >
                  ({{ data?.isPositvitePriceChange ? "+" : ""
                  }}{{ data?.defaultCurrency?.priceChange | roundNumberPrice }})
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-auto chart-filters">
            <div class="currency-switcher" *ngIf="useGlobalCurrency && data?.baseCurrency?.currency !== data?.defaultCurrency?.currency">
              <!-- Desktop pills -->
              <div class="currency-pills d-none d-lg-flex">
                <button class="filter-pill" [class.active]="showGlobalCurrency" (click)="showGlobalCurrency = true">{{ data?.defaultCurrency?.currency || globalCurrency }}</button>
                <button class="filter-pill" [class.active]="!showGlobalCurrency" (click)="showGlobalCurrency = false">{{ data?.baseCurrency?.currency }}</button>
              </div>
              <!-- Mobile dropdown -->
              <select class="filter-select d-lg-none" [(ngModel)]="showGlobalCurrency">
                <option [ngValue]="true">{{ data?.defaultCurrency?.currency || globalCurrency }}</option>
                <option [ngValue]="false">{{ data?.baseCurrency?.currency }}</option>
              </select>
            </div>
            <chart-duration-picker
              [duration]="duration"
              (durationChange)="changeDuration($event)"
            ></chart-duration-picker>
          </div>
        </div>
        <price-chart
          *ngIf="pair"
          class="chart"
          [data]="data?.livePriceHistory"
          [color]="data?.chartColor"
          [globalCurrency]="showGlobalCurrency"
        >
        </price-chart>
      </div>
      <!-- .top -->

      <!-- Mobile-only: Low/High bar directly under chart -->
      <div class="mobile-low-high d-lg-none" *ngIf="fullLayout">
        <div class="box glass-panel scroll-reveal bar-animate">
          <div class="d-flex justify-content-between">
            <div i18n="@@pricePage.range.low">Low</div>
            <div i18n="@@pricePage.range.high">High</div>
          </div>
          <div class="p-1"></div>
          <div class="bg-layer">
            <div class="accent-layer" [style]="{ width: accentWidth }"></div>
          </div>
          <div class="p-1"></div>
          <div class="d-flex justify-content-between">
            <div class="item-price">
              <div class="text-bold">{{ data?.baseCurrency?.currency }} {{ data.livePriceHistory?.baseCurrencyLimit?.min | roundNumberPrice }}</div>
              <div class="item-price text-sm text-gray" *ngIf="useGlobalCurrency && data?.baseCurrency?.currency !== data?.defaultCurrency?.currency">
                {{ data?.defaultCurrency?.currency }} {{ data.livePriceHistory?.globalCurrencyLimit?.min | roundNumberPrice }}
              </div>
            </div>
            <div class="item-price">
              <div class="text-bold">{{ data?.baseCurrency?.currency }} {{ data.livePriceHistory?.baseCurrencyLimit?.max | roundNumberPrice }}</div>
              <div class="item-price text-sm text-gray" *ngIf="useGlobalCurrency && data?.baseCurrency?.currency !== data?.defaultCurrency?.currency">
                {{ data?.defaultCurrency?.currency }} {{ data.livePriceHistory?.globalCurrencyLimit?.max | roundNumberPrice }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- fullLayout: Two-column glass layout -->
      <div class="detail-columns" *ngIf="fullLayout">
        <!-- Left column: About + Stats -->
        <div class="detail-col-left">
          <div *ngIf="currencyDetailTokenPriceToday" class="box glass-panel scroll-reveal token-price-today">
            <h2 class="about-title" i18n="@@currencyDetail.tokenPriceToday.title">{{ currency?.name }} Price in {{ baseCurrency }}</h2>
            <div class="section-content" [innerHTML]="currencyDetailTokenPriceToday | safeHtml"></div>
          </div>
          <div *ngIf="coinInfo?.text" class="box glass-panel coin-info scroll-reveal">
            <div class="about-header">
              <h2 class="about-title" i18n="@@pricePage.brief.about">About {{ currency?.name }}</h2>
              <a *ngIf="coinInfo?.links?.[0]?.link" target="_blank" [href]="coinInfo.links?.[0].link">
                <img class="icon-lg" src="assets/images/icons/{{ !fullLayout ? (theme$ | async) : 'light' }}/www.svg" alt=""/>
              </a>
            </div>
            <p class="text text-gray">{{ coinInfo.text }}</p>
          </div>

          <div class="stats-grid scroll-reveal" *ngIf="coinInfo">
            <div class="stat-card glass-panel">
              <div class="stat-label" i18n="@@pricePage.coinInfo.marketCap">Market Cap</div>
              <div class="stat-value">{{ coinInfo?.metadata?.quote?.marketCap?.currency }} {{ coinInfo?.metadata?.quote?.marketCap?.amount | number:'1.0-0' }}</div>
            </div>
            <div class="stat-card glass-panel">
              <div class="stat-label" i18n="@@pricePage.coinInfo.tradingVolume">24h Trading Volume</div>
              <div class="stat-value">{{ coinInfo?.metadata?.quote?.tradeVolume24hour?.currency }} {{ coinInfo?.metadata?.quote?.tradeVolume24hour?.amount | number:'1.0-0' }}</div>
            </div>
            <div class="stat-card glass-panel">
              <div class="stat-label" i18n="@@pricePage.coinInfo.circulatingSupply">Circulating Supply</div>
              <div class="stat-value">{{ coinInfo?.metadata?.circulatingSupply?.currency }} {{ coinInfo?.metadata?.circulatingSupply?.amount | number:'1.0-0' }}</div>
            </div>
            <div class="stat-card glass-panel">
              <div class="stat-label" i18n="@@pricePage.coinInfo.maxSupply">Max Supply</div>
              <div class="stat-value">{{ coinInfo?.metadata?.maxSupply?.currency }} {{ (coinInfo?.metadata?.maxSupply?.amount | number:'1.0-0') || '--' }}</div>
            </div>
            <div class="stat-card glass-panel">
              <div class="stat-label" i18n="@@pricePage.coinInfo.circulatingSupplyPercent">Circulating Supply (%)</div>
              <div class="stat-value">{{ coinInfo?.metadata?.circulatingSupplyPercentage }} %</div>
            </div>
            <div class="stat-card glass-panel">
              <div class="stat-label" i18n="@@pricePage.coinInfo.fullyDilutedValue">Fully Diluted Value</div>
              <div class="stat-value">{{ coinInfo?.metadata?.quote?.fullyDilutedValue?.currency }} {{ coinInfo?.metadata?.quote?.fullyDilutedValue?.amount | number:'1.0-0' }}</div>
            </div>
            <div class="stat-card glass-panel">
              <div class="stat-label" i18n="@@pricePage.coinInfo.tokenIssueDate">Token Issue Date</div>
              <div class="stat-value">{{ coinInfo?.metadata?.issuanceDate || '--' }}</div>
            </div>
            <div class="stat-card glass-panel">
              <div class="stat-label" i18n="@@pricePage.coinInfo.auditDetails">Audit Details</div>
              <div class="stat-value">
                <a *ngIf="coinInfo?.metadata?.smartContractAudit?.auditor" [href]="coinInfo?.metadata?.smartContractAudit?.link" target="_blank" rel="noopener noreferrer" class="stat-link">{{ coinInfo?.metadata?.smartContractAudit?.auditor }}</a>
                <ng-container *ngIf="!coinInfo?.metadata?.smartContractAudit?.auditor" i18n="@@pricePage.coinInfo.auditDetailsNotAvailable">Not currently available</ng-container>
              </div>
            </div>
            <div class="stat-card glass-panel">
              <div class="stat-label" i18n="@@pricePage.coinInfo.auditDate">Audit Date</div>
              <div class="stat-value">
                <ng-container *ngIf="coinInfo?.metadata?.smartContractAudit?.date">{{ coinInfo?.metadata?.smartContractAudit?.date * 1000 | date:'dd/MM/yyyy' }}</ng-container>
                <ng-container *ngIf="!coinInfo?.metadata?.smartContractAudit?.date" i18n="@@pricePage.coinInfo.auditDetailsNotAvailable">Not currently available</ng-container>
              </div>
            </div>
          </div>
        </div>

        <!-- Right column: Low/High (desktop only), Rating -->
        <div class="detail-col-right">
          <div class="box glass-panel scroll-reveal bar-animate d-none d-lg-block">
            <div class="d-flex justify-content-between">
              <div i18n="@@pricePage.range.low">Low</div>
              <div i18n="@@pricePage.range.high">High</div>
            </div>
            <div class="p-1"></div>
            <div class="bg-layer">
              <div class="accent-layer" [style]="{ width: accentWidth }"></div>
            </div>
            <div class="p-1"></div>
            <div class="d-flex justify-content-between">
              <div class="item-price">
                <div class="text-bold">{{ data?.baseCurrency?.currency }} {{ data.livePriceHistory?.baseCurrencyLimit?.min | roundNumberPrice }}</div>
                <div class="item-price text-sm text-gray" *ngIf="useGlobalCurrency && data?.baseCurrency?.currency !== data?.defaultCurrency?.currency">
                  {{ data?.defaultCurrency?.currency }} {{ data.livePriceHistory?.globalCurrencyLimit?.min | roundNumberPrice }}
                </div>
              </div>
              <div class="item-price">
                <div class="text-bold">{{ data?.baseCurrency?.currency }} {{ data.livePriceHistory?.baseCurrencyLimit?.max | roundNumberPrice }}</div>
                <div class="item-price text-sm text-gray" *ngIf="useGlobalCurrency && data?.baseCurrency?.currency !== data?.defaultCurrency?.currency">
                  {{ data?.defaultCurrency?.currency }} {{ data.livePriceHistory?.globalCurrencyLimit?.max | roundNumberPrice }}
                </div>
              </div>
            </div>
          </div>

          <div class="box glass-panel scroll-reveal bar-animate" *ngIf="coinRating?.score">
            <h3 class="box-title token-insight-title" i18n="@@pricePage.analytics.rating">
              <span>Rating</span>
              <a href="#" (click)="onTokenInsightInfoClick($event)" class="text-end">by TokenInsight <i class="icon-info"></i></a>
            </h3>
            <div class="p-1"></div>
            <ng-container *ngTemplateOutlet="tokenInsightsRatingHeader"></ng-container>
            <div class="p-1"></div>
            <div class="row">
              <ng-container *ngTemplateOutlet="tokenInsightsRating; context: { accentWidth: coinRating?.underlyingTechnologySecurity, ratingType: TokenRatingType.TS, ratingStyle: getScoreBadge(coinRating?.underlyingTechnologySecurity), ratingWidth: 'col-lg-4' }"></ng-container>
              <ng-container *ngTemplateOutlet="tokenInsightsRating; context: { accentWidth: coinRating?.roadmapProgress, ratingType: TokenRatingType.GP, ratingStyle: getScoreBadge(coinRating?.roadmapProgress), ratingWidth: 'col-lg-4' }"></ng-container>
              <ng-container *ngTemplateOutlet="tokenInsightsRating; context: { accentWidth: coinRating?.tokenEconomics, ratingType: TokenRatingType.TE, ratingStyle: getScoreBadge(coinRating?.tokenEconomics), ratingWidth: 'col-lg-4' }"></ng-container>
              <ng-container *ngTemplateOutlet="tokenInsightsRating; context: { accentWidth: coinRating?.tokenPerformance, ratingType: TokenRatingType.LP, ratingStyle: getScoreBadge(coinRating?.tokenPerformance), ratingWidth: 'col-lg-4' }"></ng-container>
              <ng-container *ngTemplateOutlet="tokenInsightsRating; context: { accentWidth: coinRating?.teamPartnersInvestors, ratingType: TokenRatingType.SK, ratingStyle: getScoreBadge(coinRating?.teamPartnersInvestors), ratingWidth: 'col-lg-4' }"></ng-container>
              <ng-container *ngTemplateOutlet="tokenInsightsRating; context: { accentWidth: coinRating?.ecosystemDevelopment, ratingType: TokenRatingType.ES, ratingStyle: getScoreBadge(coinRating?.ecosystemDevelopment), ratingWidth: 'col-lg-4' }"></ng-container>
            </div>
            <div class="text-end">
              <a href="#" i18n="@@pricePage.analytics.rating.see.details" (click)="onTokenInsightDetailsClick()">See Details</a>
            </div>
          </div>

        </div>
      </div>

      <!-- Currency detail sections from blog -->
      <div *ngIf="fullLayout && (currencyDetailHowToBuy || currencyDetailWhyTrade || currencyDetailFaqs)" class="currency-detail-sections">
        <div class="currency-detail-row" *ngIf="currencyDetailHowToBuy || currencyDetailWhyTrade">
          <div *ngIf="currencyDetailHowToBuy" class="box glass-panel scroll-reveal">
            <currency-how-to-buy
              [content]="currencyDetailHowToBuy"
              [currencyName]="currency?.name"
              [fiatCode]="baseCurrency">
            </currency-how-to-buy>
          </div>
          <div *ngIf="currencyDetailWhyTrade" class="box glass-panel scroll-reveal">
            <currency-why-trade
              [content]="currencyDetailWhyTrade"
              [currencyName]="currency?.name">
            </currency-why-trade>
          </div>
        </div>
        <div *ngIf="currencyDetailFaqs" class="box glass-panel scroll-reveal">
          <currency-faqs
            [content]="currencyDetailFaqs">
          </currency-faqs>
        </div>
      </div>

      <!-- !fullLayout: Original dashboard layout -->
      <ng-container *ngIf="!fullLayout">
      <div class="row">
        <div class="coin-info-dashboard">
          <div class="left">
            <div class="box">
              <div class="d-flex justify-content-between">
                <div i18n="@@pricePage.range.low">Low</div>
                <div i18n="@@pricePage.range.high">High</div>
              </div>
              <div class="p-2"></div>
              <div class="bg-layer">
                <div class="accent-layer" [style]="{ width: accentWidth }"></div>
              </div>
              <div class="p-2"></div>
              <div class="d-flex justify-content-between">
                <div class="item-price">
                  <div class="text-bold">
                    {{ data?.baseCurrency?.currency }}
                    {{ data.livePriceHistory?.baseCurrencyLimit?.min | roundNumberPrice }}
                  </div>
                  <div class="item-price text-sm text-gray" *ngIf="useGlobalCurrency && data?.baseCurrency?.currency !== data?.defaultCurrency?.currency">
                    {{ data?.defaultCurrency?.currency }}
                    {{ data.livePriceHistory?.globalCurrencyLimit?.min | roundNumberPrice }}
                  </div>
                </div>
                <div class="item-price">
                  <div class="text-bold">
                    {{ data?.baseCurrency?.currency }}
                    {{ data.livePriceHistory?.baseCurrencyLimit?.max | roundNumberPrice }}
                  </div>
                  <div class="item-price text-sm text-gray" *ngIf="useGlobalCurrency && data?.baseCurrency?.currency !== data?.defaultCurrency?.currency">
                    {{ data?.defaultCurrency?.currency }}
                    {{ data.livePriceHistory?.globalCurrencyLimit?.max | roundNumberPrice }}
                  </div>
                </div>
              </div>
            </div>
            <div class="box" *ngIf="coinRating?.score">
              <h3 class="box-title token-insight-title" i18n="@@pricePage.analytics.rating">
                <span>Rating</span>
                <a href="#" (click)="onTokenInsightInfoClick($event)" class="text-end">by TokenInsight <i class="icon-info"></i></a>
              </h3>
              <div class="p-1"></div>
              <ng-container *ngTemplateOutlet="tokenInsightsRatingHeader"></ng-container>
              <div class="p-1"></div>
              <div class="row">
                <ng-container *ngTemplateOutlet="tokenInsightsRating; context: { accentWidth: coinRating?.underlyingTechnologySecurity, ratingType: TokenRatingType.TS, ratingStyle: getScoreBadge(coinRating?.underlyingTechnologySecurity), ratingWidth: 'col-lg-4' }"></ng-container>
                <ng-container *ngTemplateOutlet="tokenInsightsRating; context: { accentWidth: coinRating?.roadmapProgress, ratingType: TokenRatingType.GP, ratingStyle: getScoreBadge(coinRating?.roadmapProgress), ratingWidth: 'col-lg-4' }"></ng-container>
                <ng-container *ngTemplateOutlet="tokenInsightsRating; context: { accentWidth: coinRating?.tokenEconomics, ratingType: TokenRatingType.TE, ratingStyle: getScoreBadge(coinRating?.tokenEconomics), ratingWidth: 'col-lg-4' }"></ng-container>
                <ng-container *ngTemplateOutlet="tokenInsightsRating; context: { accentWidth: coinRating?.tokenPerformance, ratingType: TokenRatingType.LP, ratingStyle: getScoreBadge(coinRating?.tokenPerformance), ratingWidth: 'col-lg-4' }"></ng-container>
                <ng-container *ngTemplateOutlet="tokenInsightsRating; context: { accentWidth: coinRating?.teamPartnersInvestors, ratingType: TokenRatingType.SK, ratingStyle: getScoreBadge(coinRating?.teamPartnersInvestors), ratingWidth: 'col-lg-4' }"></ng-container>
                <ng-container *ngTemplateOutlet="tokenInsightsRating; context: { accentWidth: coinRating?.ecosystemDevelopment, ratingType: TokenRatingType.ES, ratingStyle: getScoreBadge(coinRating?.ecosystemDevelopment), ratingWidth: 'col-lg-4' }"></ng-container>
              </div>
              <div class="text-end">
                <a href="#" i18n="@@pricePage.analytics.rating.see.details" (click)="onTokenInsightDetailsClick()">See Details</a>
              </div>
            </div>
            <div class="box">
              <h3 class="about-title" i18n="@@pricePage.brief.audit">Audit</h3>
              <div class="divider"></div>
              <div class="row my-4">
                <div class="col-6 text-md text-bold-light" i18n="@@pricePage.coinInfo.auditDetails">Audit Details</div>
                <div class="col-6 text-md text-bold-light" i18n="@@pricePage.coinInfo.auditDate">Audit Date</div>
                <div class="col-6 token-updated">
                  <a *ngIf="coinInfo?.metadata?.smartContractAudit?.auditor" [href]="coinInfo?.metadata?.smartContractAudit?.link" target="_blank" rel="noopener noreferrer">
                    {{ coinInfo?.metadata?.smartContractAudit?.auditor }}
                  </a>
                  <ng-container *ngIf="!coinInfo?.metadata?.smartContractAudit?.auditor" i18n="@@pricePage.coinInfo.auditDetailsNotAvailable">Not currently available</ng-container>
                </div>
                <div class="col-6 token-updated">
                  <ng-container *ngIf="coinInfo?.metadata?.smartContractAudit?.date">{{ coinInfo?.metadata?.smartContractAudit?.date * 1000 | date : "dd/MM/yyyy" }}</ng-container>
                  <ng-container *ngIf="!coinInfo?.metadata?.smartContractAudit?.date" i18n="@@pricePage.coinInfo.auditDetailsNotAvailable">Not currently available</ng-container>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div *ngIf="coinInfo?.text" class="box coin-info">
              <h3 class="about-title" i18n="@@pricePage.brief.about">About {{ currency?.name }}</h3>
              <div class="box-title">
                <a *ngIf="coinInfo?.links?.[0]?.link" target="_blank" [href]="coinInfo.links?.[0].link">
                  <img class="icon-lg" src="assets/images/icons/{{ !fullLayout ? (theme$ | async) : 'light' }}/www.svg" alt=""/>
                </a>
              </div>
              <p class="text text-gray">{{ coinInfo.text }}</p>
              <div class="row mb-4">
                <div class="col-6 text-md text-bold-light" i18n="@@pricePage.coinInfo.marketCap">Market Cap</div>
                <div class="col-6 text-md text-bold-light" i18n="@@pricePage.coinInfo.tradingVolume">24h Trading Volume</div>
                <div class="col-6 token-updated">{{ coinInfo?.metadata?.quote?.marketCap?.currency }} {{ coinInfo?.metadata?.quote?.marketCap?.amount || "--" | number : "1.0-0" }}</div>
                <div class="col-6 token-updated">{{ coinInfo?.metadata?.quote?.tradeVolume24hour?.currency }} {{ coinInfo?.metadata?.quote?.tradeVolume24hour?.amount || "--" | number : "1.0-0" }}</div>
              </div>
              <div class="row mb-4">
                <div class="col-6 text-md text-bold-light" i18n="@@pricePage.coinInfo.circulatingSupply">Circulating Supply</div>
                <div class="col-6 text-md text-bold-light" i18n="@@pricePage.coinInfo.maxSupply">Max Supply</div>
                <div class="col-6 token-updated">{{ coinInfo?.metadata?.circulatingSupply?.currency }} {{ coinInfo?.metadata?.circulatingSupply?.amount || "--" | number : "1.0-0" }}</div>
                <div class="col-6 token-updated">{{ coinInfo?.metadata?.maxSupply?.currency }} {{ (coinInfo?.metadata?.maxSupply?.amount | number : "1.0-0") || "--" }}</div>
              </div>
              <div class="row mb-4">
                <div class="col-6 text-md text-bold-light" i18n="@@pricePage.coinInfo.circulatingSupplyPercent">Circulating Supply (%)</div>
                <div class="col-6 text-md text-bold-light" i18n="@@pricePage.coinInfo.fullyDilutedValue">Fully Diluted Value</div>
                <div class="col-6 token-updated">{{ coinInfo?.metadata?.circulatingSupplyPercentage }} %</div>
                <div class="col-6 token-updated">{{ coinInfo?.metadata?.quote?.fullyDilutedValue?.currency }} {{ coinInfo?.metadata?.quote?.fullyDilutedValue?.amount || "--" | number : "1.0-0" }}</div>
              </div>
              <div class="row">
                <div class="col-6 text-md text-bold-light" i18n="@@pricePage.coinInfo.tokenIssueDate">Token Issue Date</div>
                <div class="col-6 text-md text-bold-light" i18n="@@pricePage.coinInfo.tradingVolume"></div>
                <div class="col-6 token-updated">{{ coinInfo?.metadata?.issuanceDate || "--" }}</div>
                <div class="col-6 token-updated"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </ng-container>
    </div>
    <!-- .wrapper -->
  </ng-template>
  <ng-template #emptyPrice>
    <div class="col-auto">--</div>
  </ng-template>
  <ng-template #tokenInsightsRatingHeader>
    <div class="row">
      <div class="col-6">
        <div class="text-xxl text-bold rating {{ coinRating?.badge }}">
          {{ coinRating?.level }}
        </div>
        <div class="text-bold" i18n="@@pricePage.analytics.stability">
          Stable
        </div>
      </div>
      <div class="col-6 text-end">
        <div class="text-xxl">
          {{ coinRating?.score || 0 | number : "1.2-2" }}%
        </div>
        <div class="token-updated text-sm"></div>
      </div>
    </div>
  </ng-template>
  <ng-template
    #tokenInsightsRating
    let-accentWidth="accentWidth"
    let-ratingType="ratingType"
    let-ratingStyle="ratingStyle"
    let-ratingWidth="ratingWidth"
  >
    <div class="{{ ratingWidth }} p-2">
      <div class="bg-layer">
        <div
          class="accent-layer {{ ratingStyle }}"
          [style]="{ width: accentWidth + '%' }"
        ></div>
      </div>
      <div class="d-flex justify-content-between py-1 text-sm text-gray">
        <div>
          <ng-container [ngSwitch]="ratingType">
            <ng-container
              *ngSwitchCase="TokenRatingType.TS"
              i18n="@@pricePage.analytics.token.insights.ts"
              >Technology & security</ng-container
            >
            <ng-container
              *ngSwitchCase="TokenRatingType.GP"
              i18n="@@pricePage.analytics.token.insights.gp"
              >Goals & progress</ng-container
            >
            <ng-container
              *ngSwitchCase="TokenRatingType.TE"
              i18n="@@pricePage.analytics.token.insights.te"
              >Token economics</ng-container
            >
            <ng-container
              *ngSwitchCase="TokenRatingType.LP"
              i18n="@@pricePage.analytics.token.insights.lp"
              >Liquidity & perf.</ng-container
            >
            <ng-container
              *ngSwitchCase="TokenRatingType.SK"
              i18n="@@pricePage.analytics.token.insights.sk"
              >Stakeholders</ng-container
            >
            <ng-container
              *ngSwitchCase="TokenRatingType.ES"
              i18n="@@pricePage.analytics.token.insights.es"
              >Ecosystem</ng-container
            >
          </ng-container>
        </div>
        <div class="text-bold">{{ accentWidth || 0 | number : "1.1-2" }}%</div>
      </div>
    </div>
  </ng-template>

  <modal
    class="info-modal"
    [show]="showTokenInsightInfoModal"
    size="md"
    [x]="false"
    (onClose)="onTokenInsightInfoClose()"
  >
    <div class="wrapper px-3">
      <h3
        class="box-title text-center"
        i18n="@@pricePage.analytics.token.insights.info.title"
      >
        About TokenInsight
      </h3>
      <div class="p-2"></div>
      <p i18n="@@pricePage.analytics.token.insights.description.text1">
        This data is sourced directly from our partner, TokenInsight.
        TokenInsight is an independent Crypto Research firm that delivers
        unbiased data, analytics, and ratings since 2018, through comprehensive
        blockchain industry classification system and proprietary rating
        research mechanisms.
      </p>
      <p i18n="@@pricePage.analytics.token.insights.description.text2">
        BitOasis is not responsible for the accuracy or timeliness of any data.
        This data does not constitute investment advice and should not be relied
        upon, or replace your own research, for investment purposes. BitOasis
        shall not be responsible for any losses arising from any investment
        based on this data.
      </p>
      <button
        class="btn btn-primary btn-block"
        (click)="onTokenInsightInfoClose()"
        i18n="@@pricePage.analytics.token.insights.closeAction"
      >
        Close
      </button>
      <div class="p-2"></div>
    </div>
  </modal>

  <modal
    class="info-modal"
    [show]="showTokenInsightDetailsModal"
    size="lg"
    [x]="false"
    (onClose)="onTokenInsightDetailsClose()"
  >
    <div class="wrapper px-3">
      <h3
        class="box-title text-center"
        i18n="@@pricePage.analytics.token.insights.details.title"
      >
        Rating
      </h3>
      <div class="p-2"></div>
      <ng-container
        *ngTemplateOutlet="tokenInsightsRatingHeader"
      ></ng-container>
      <div class="p-2"></div>
      <div class="row">
        <ng-container
          *ngTemplateOutlet="
            tokenInsightsRating;
            context: {
              accentWidth: coinRating?.underlyingTechnologySecurity,
              ratingType: TokenRatingType.TS,
              ratingStyle: getScoreBadge(
                coinRating?.underlyingTechnologySecurity
              ),
              ratingWidth: 'col-12'
            }
          "
        ></ng-container>
        <p i18n="@@pricePage.analytics.token.insights.ts.description">
          Evaluation of security and stability of the project's underlying
          technology in the dimension.
        </p>
        <ng-container
          *ngTemplateOutlet="
            tokenInsightsRating;
            context: {
              accentWidth: coinRating?.roadmapProgress,
              ratingType: TokenRatingType.GP,
              ratingStyle: getScoreBadge(coinRating?.roadmapProgress),
              ratingWidth: 'col-12'
            }
          "
        ></ng-container>
        <p i18n="@@pricePage.analytics.token.insights.gp.description">
          Evaluation of initial development goals set by team, the iterations of
          the roadmap, and the on-time delivery of key milestones.
        </p>
        <ng-container
          *ngTemplateOutlet="
            tokenInsightsRating;
            context: {
              accentWidth: coinRating?.tokenEconomics,
              ratingType: TokenRatingType.TE,
              ratingStyle: getScoreBadge(coinRating?.tokenEconomics),
              ratingWidth: 'col-12'
            }
          "
        ></ng-container>
        <p i18n="@@pricePage.analytics.token.insights.te.description">
          Evaluation of usage scenarios of native tokens, distribution & vesting
          plans, and holdings.
        </p>
        <ng-container
          *ngTemplateOutlet="
            tokenInsightsRating;
            context: {
              accentWidth: coinRating?.tokenPerformance,
              ratingType: TokenRatingType.LP,
              ratingStyle: getScoreBadge(coinRating?.tokenPerformance),
              ratingWidth: 'col-12'
            }
          "
        ></ng-container>
        <p i18n="@@pricePage.analytics.token.insights.lp.description">
          Evaluation of liquidity of the native token in the secondary market
          and its historical price performance in the context of the overall
          market.
        </p>
        <ng-container
          *ngTemplateOutlet="
            tokenInsightsRating;
            context: {
              accentWidth: coinRating?.teamPartnersInvestors,
              ratingType: TokenRatingType.SK,
              ratingStyle: getScoreBadge(coinRating?.teamPartnersInvestors),
              ratingWidth: 'col-12'
            }
          "
        ></ng-container>
        <p i18n="@@pricePage.analytics.token.insights.sk.description">
          Evaluation of development team in terms of the size, stability, and
          strength, plus the strength and reputation of the partner and
          investor.
        </p>
        <ng-container
          *ngTemplateOutlet="
            tokenInsightsRating;
            context: {
              accentWidth: coinRating?.ecosystemDevelopment,
              ratingType: TokenRatingType.ES,
              ratingStyle: getScoreBadge(coinRating?.ecosystemDevelopment),
              ratingWidth: 'col-12'
            }
          "
        ></ng-container>
        <p i18n="@@pricePage.analytics.token.insights.es.description">
          Evaluation of collaboration with other projects, supplemented by an
          examination of social media activity and decentralized governance
          participation.
        </p>
      </div>
      <button
        class="btn btn-primary btn-block"
        (click)="onTokenInsightDetailsClose()"
        i18n="@@pricePage.analytics.token.insights.closeAction"
      >
        Close
      </button>
      <div class="p-2"></div>
    </div>
  </modal>
</ng-container>
